import React from "react";

const POSITION_GROUPS = [
  { label: "HORSE FRONT", positions: [1, 2], narrow: true },
  { label: "HORSE REAR", positions: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14] },
  { label: "TRAILER 1", positions: [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26] },
  { label: "TRAILER 2", positions: [27, 28, 29, 30, 31, 32], narrow: true },
];

const TyrePositionPicker = ({ selectedTyres, onToggleTyre }) => (
  <div className="tyre-position-grid">
    <div className="tyre-position-front">FRONT OF VEHICLE</div>
    {POSITION_GROUPS.map((group) => (
      <div className="tyre-position-group" key={group.label}>
        <div className="tyre-position-label">{group.label}</div>
        <div className={`tyre-position-buttons ${group.narrow ? "tyre-position-buttons--narrow" : ""}`}>
          {group.positions.map((position) => (
            <button
              className={`tyre-position-button ${selectedTyres.includes(position) ? "is-selected" : ""}`}
              key={position}
              onClick={() => onToggleTyre(position)}
              type="button"
            >
              {position}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default TyrePositionPicker;
